import { InputAdornment, TextField } from '@mui/material';
import { useFormikContext } from 'formik';
import { NumericFormat } from 'react-number-format';
import { TAssetInvestmentDetailsSchema } from '@brickwise/asset-validation/dist/asset/investmentData';
import { useEffect, useState, FC } from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

export const TotalIssuePrice: FC<{ disabled?: boolean }> = ({ disabled }) => {
  const formik = useFormikContext<TAssetInvestmentDetailsSchema>();
  const sharePrice = formik.values.investmentDetails?.sharePrice;
  const totalBricks = formik.values.investmentDetails?.totalBricks;

  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);

  // Make sure to initialize the `totalIssuePrice` state with the `sharePrice` and `totalBricks` values if they exist
  const [totalIssuePrice, setTotalIssuePrice] = useState(sharePrice && totalBricks ? sharePrice * totalBricks : 0);

  // Update the Formik `sharePrice` field when the `totalIssuePrice` or `totalBricks` changes
  useEffect(() => {
    if (totalBricks && totalIssuePrice) {
      formik.setFieldValue('investmentDetails.sharePrice', totalIssuePrice / totalBricks);
    }
  }, [totalIssuePrice, totalBricks]);

  //Check Whether you should trigger errors or not
  const sharePriceErrors = _.get(formik.errors, 'investmentDetails.sharePrice');
  useEffect(() => {
    setErrorMessage(sharePriceErrors);
  }, [sharePriceErrors]);

  const { t } = useTranslation();

  return (
    <NumericFormat
      customInput={TextField}
      margin="normal"
      label={t('dashboard.assets.addedit.investment.issuepricecalculation.fields.totalissueprice.label')}
      type="text"
      variant="outlined"
      fullWidth
      disabled={disabled}
      decimalScale={2}
      decimalSeparator=","
      onValueChange={(values) => {
        if (values.floatValue) setTotalIssuePrice(values.floatValue);
      }}
      fixedDecimalScale
      error={!!errorMessage}
      helperText={errorMessage}
      // disabled={disabled}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start" sx={{ mr: 1 }}>
            €
          </InputAdornment>
        ),
      }}
    />
  );
};
